import {FC} from 'react';
import UITextarea from '../UICommon/UITextarea';
import HealthDeclarationRadioButtons from './HealthDeclarationRadioButtons';

type HealthDeclarationQuestionProps = {
  title: string;
  type: string;
  currentQuestionId: number;
  currentQuestionIdx: number;
  content: any;
  lastQuestion: boolean;
  setSelectedCheckboxes: Function;
  selectedCheckboxes: Array<any>;
  handleTextareaChange: Function;
  fillText: string;
  selected: Array<any>;
}

const HealthDeclarationQuestion: FC<HealthDeclarationQuestionProps> = ({
  title,
  type,
  currentQuestionId,
  currentQuestionIdx,
  content,
  lastQuestion,
  setSelectedCheckboxes,
  selectedCheckboxes,
  handleTextareaChange,
  fillText,
  selected,
}) => {
  if (type === 'boolean') {
    return (
      <>
        <div className='flex justify-between'>
          <div className='font-Outfit text-26 font-semibold text-navy-primary pb-1'>
            {currentQuestionIdx}. {title}
          </div>
          <div className='flex space-x-4 font-Outline pr-3 text-center'>
            <div className='flex flex-col justify-center'>
              <div className='font-semibold text-md'>Ja</div>
              <div className='font-medium text-sm'>Yes</div>
            </div>
            <div className='flex flex-col justify-center'>
              <div className='font-semibold text-md'>Nej</div>
              <div className='font-medium text-sm'>No</div>
            </div>
          </div>
        </div>
        <div className={` pr-3`}>
          {content.map((el: any, idx: number) => (
            <div key={idx} className="py-2 border-b border-navy-primary flex justify-between items-center">
              <div>
                <div className='font-semibold text-lg leading-5 pb-2'>{el.name}</div>
                <div className='font-normal text-base leading-[18px]'>{el.text}</div>
              </div>
              <HealthDeclarationRadioButtons
                setSelectedCheckboxes={setSelectedCheckboxes}
                selectedCheckboxes={selectedCheckboxes}
                id={el.id}
                currentQuestionId={currentQuestionId}
                selected={selected}
              />
            </div>
          ))}
        </div>
      </>
    );
  }
  return (
    <>
      <div className='font-Outfit text-26 font-semibold text-navy-primary pb-2'>
        {currentQuestionIdx}. {title}
      </div>
      <div className={`${lastQuestion ? 'h-[51%]' : 'h-[61%]'} overflow-scroll`}>
        {content.map((el: any, idx: number) => (
          <div key={idx} className="py-3">
            <div className='font-semibold text-lg'>{el.name}</div>
            <div className='font-normal text-base leading-5' dangerouslySetInnerHTML={{__html: el.text}}></div>
            {type === 'fill' && (
              <div className='pt-8'>
                <div className='text-xs font-Manrope font-bold py-2'>Vänligen fyll text nedan.</div>
                <UITextarea
                  handleTextareaChange={handleTextareaChange}
                  fillText={fillText}/>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default HealthDeclarationQuestion;
